import { ISocialInstitution } from '../../../interfaces';

class SocialInstitutionMapper {
    toPersistence(domain: ISocialInstitution): any {
        return {
            cnpj: domain.cnpj,
            name: domain.name,
            active: domain.active,
        }
    }

    toDomain(persistence: any): ISocialInstitution {
        return {
            id: persistence.id,
            cnpj: persistence.cnpj,
            name: persistence.name,
            active: persistence.active,
            created_at: persistence.created_at,
            total_users: persistence.total_users
        }
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new SocialInstitutionMapper();
